"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CountryTranslationReducer = exports.CountryReducer = undefined;

var _nodeToolbox = require("@esnpm/node-toolbox");

var _apiCountries = require("../actions/esdb/apiCountries");

var _translate = require("@esnpm/translate");

var CountryReducer = exports.CountryReducer = function CountryReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        data: null,
        loading: false,
        error: null
    };
    var action = arguments[1];


    switch (action.type) {
        case _apiCountries.API_COUNTRIES_SUCCESS:
            return Object.assign({}, action.payload);
            break;
        default:
            return state;
    }
};

var CountryTranslationReducer = exports.CountryTranslationReducer = function CountryTranslationReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        loading: false,
        data: null,
        error: null
    };
    var action = arguments[1];


    switch (action.type) {
        case _apiCountries.API_COUNTRIES_SUCCESS:
            if (action.payload.data == {} || action.payload.data == null) {
                return state;
            }
            var newState = {};
            var trCountries = {};
            Object.values(action.payload.data).map(function (v) {
                trCountries[v.COUNTRY_CODE] = v.NAME;
            });
            newState = (0, _translate.registerTranslation)(state, "countries", trCountries);

            return newState;

        default:
            return state;
    }
};